/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Col_BagsInputs */

const vi_sinp_col_bags = /** @type {(inputs: Sinp_Col_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số bao`)
};

/**

* @param {Sinp_Col_BagsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_col_bags = /** @type {((inputs?: Sinp_Col_BagsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Col_BagsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_col_bags(inputs)
});